import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/
export const constantRouterMap = [
  {path: '/admin/entrance', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {path: '/store', component: () => import('@/views/rms/view.vue'), hidden: true},
  {path: '/appDetails', component: () => import('@/views/rms/AppDetails.vue'), hidden: true},
  {path: '/appDownload', component: () => import('@/views/rms/appDownload.vue'), hidden: true},
  {path: '/apkDownload', component: () => import('@/views/rms/ApkDownload.vue'), hidden: true},
  {path: '/pms/productAttr', redirect: '/pms/productAttr/index', hidden: true},
  {path: '/pms/productCate', redirect: '/pms/productCate/index', hidden: true},
  {path: '/', redirect: '/home', hidden: true},
  /*{
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }*/
]

export const asyncRouterMap = [
  {
    path: '/home',
    component: Layout,
    sort: 100,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/platform/dashboard/index'),
        meta: {title: '首页', icon: 'home'}
      }
    ]
  },
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '应用管理', icon: 'product'},
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '应用列表', icon: 'product-list'}
      },
      {
        path: 'productAttr/index',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '应用图标', icon: 'product-attr'}
      },
      {
        path: 'productCate/index',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '应用分类', icon: 'product-cate'}
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'operLog',
        name: 'operLog',
        component: () => import('@/views/ums/operLog/index'),
        meta: {title: '操作日志', icon: 'order'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配权限'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单权限', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'},
        hidden: true
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path: '/platform',
    component: Layout,
    redirect: '/platform/config',
    name: 'platform',
    meta: {title: '中台', icon: 'example'},
    children: [
      {
        path: 'config',
        name: 'platformConfig',
        component: () => import('@/views/platform/config/index'),
        meta: {title: '配置列表', icon: 'form'}
      },
      {
        path: 'instanceServer',
        name: 'instanceServer',
        component: () => import('@/views/instance/server/index'),
        meta: {title: '服务实例', icon: 'table'}
      },
      {
        path: 'deployServer',
        redirect: '/platform/instanceServer',
        hidden: true
      },
      {
        path: 'etvServer',
        redirect: '/platform/instanceServer',
        hidden: true
      },
      {
        path: 'msgLog',
        name: 'msgLog',
        component: () => import('@/views/message/log/index'),
        meta: {title: '消息记录', icon: 'sms'}
      },
      {
        path: 'weatherQuery',
        name: 'weatherQuery',
        component: () => import('@/views/weather/query/index'),
        meta: {title: '天气查询', icon: 'marker'}
      },
      {
        path: 'payOrder',
        name: 'payOrder',
        component: () => import('@/views/pay/order/index'),
        meta: {title: '聚合支付', icon: 'money'}
      },
      {
        path: 'payNotifyLog',
        name: 'payNotifyLog',
        component: () => import('@/views/pay/notifyLog/index'),
        meta: {title: '回调日志', icon: 'order'}
      },
      {
        path: 'openApp',
        name: 'platformOpenApp',
        component: () => import('@/views/platform/openApp/index'),
        meta: {title: '开放应用', icon: 'user'}
      },
      {
        path: 'apiQuota',
        name: 'apiQuota',
        component: () => import('@/views/openapi/quota/index'),
        meta: {title: 'API配额', icon: 'form'}
      },
      {
        path: 'apiCallLog',
        name: 'apiCallLog',
        component: () => import('@/views/openapi/log/index'),
        meta: {title: '调用日志', icon: 'table'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js